// Animation durations in seconds
export const SESSION_ANIMATION_DURATIONS = {
  LAYOUT_TRANSITION: 0.3,
  HEADER_TEXT_FADE: 0.2,
  CONTENT_COLLAPSE: 0.1,
} as const;

// Text displayed in various UI states
export const SESSION_THOUGHT_PROCESS_TEXTS = {
  THINKING: "Thinking...",
  PROCESSING: "Processing...",
  SHOW_THOUGHT_PROCESS: "Show thought process",
  HIDE_THOUGHT_PROCESS: "Hide thought process",
} as const;

// Text truncation settings
export const SESSION_TEXT_DISPLAY_CONFIG = {
  MAX_HEADER_LENGTH: 50,
  TRUNCATION_SUFFIX: "...",
  TRUNCATION_BUFFER: 3,
} as const;

// Stagger delay between event animations
export const SESSION_EVENT_FADE_IN_DELAY = 0.1;
